import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { changeShareTable, getShareDetail, fetchShareMeterList } from "@/api/PMS/baseInformation/meterManager";
import { fetchList as getMeterTypeList } from "@/api/PMS/baseInformation/meterType";
export default {
  data: function data() {
    return {
      rules: {
        meterId: [{
          required: true,
          message: "请选择仪表类型",
          trigger: "blur"
        }],
        currentReadOld: [{
          required: true,
          type: "number",
          message: "请输入初始读数，类型为数字",
          trigger: "blur",
          transform: function transform(value) {
            return Number(value);
          }
        }],
        currentRead: [{
          required: true,
          type: "number",
          message: "请输入初始读数，类型为数字",
          trigger: "blur",
          transform: function transform(value) {
            return Number(value);
          }
        }],
        meterPower: [{
          required: true,
          type: "number",
          message: "请输入倍率，类型为数字",
          trigger: "blur",
          transform: function transform(value) {
            return Number(value);
          }
        }],
        returnTrip: [{
          required: true,
          type: "number",
          message: "请输入回程，类型为数字",
          trigger: "blur",
          transform: function transform(value) {
            return Number(value);
          }
        }],
        readDate: [{
          required: true,
          message: "请选择更换日期",
          trigger: "blur"
        }],
        meterWastageRate: [{
          required: true,
          type: "number",
          transform: function transform(value) {
            console.log(Number(value));
            if (value !== undefined && value !== null) return Number(value);
          },
          message: "损耗率类型为数字",
          trigger: "blur"
        }],
        shareMeterName: [{
          required: true,
          message: "请输入新仪表名称",
          trigger: "blur"
        }],
        readDateOld: [{
          required: true,
          message: "请选择初始日期",
          trigger: "blur"
        }],
        shareMeterNameOld: [{
          required: true,
          message: "请输入仪表名称",
          trigger: "blur"
        }]
      },
      meterId: 0,
      shareMeterList: [],
      meterTypeList: [],
      childData: {
        meterName: "",
        changeReadNumber: 0
      }
    };
  },
  props: ["keyValue", "showDialog"],
  created: function created() {
    this.init();
    this.loadMeterTypeList();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs["dataForm"].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          shareMeterId: this.keyValue
        };
        getShareDetail(queryData).then(function (response) {
          _this.childData = response.data.data; // this.childData.changeReadNumber = 0;
          // 转化新数据，清理旧数据

          console.log(_this.childData);
          _this.childData.shareMeterNameOld = _this.childData.shareMeterName;
          _this.childData.currentReadOld = _this.childData.currentRead;
          _this.childData.readDateOld = _this.childData.readDate; // 清理旧数据

          _this.$set(_this.childData, "changeReadNumber", 0);

          delete _this.childData.shareMeterName;
          delete _this.childData.currentRead;
          delete _this.childData.readDate;
          delete _this.childData.meterPower;
          delete _this.childData.meterWastageRate;
          delete _this.childData.returnTrip;
        });
      } else {
        this.meterId = "";
        this.childData = {
          meterName: ""
        };
      }
    },
    // 获取仪表类型
    loadMeterTypeList: function loadMeterTypeList() {
      var _this2 = this;

      getMeterTypeList({}).then(function (r) {
        _this2.meterTypeList = r.data.data;
      });
    },
    handCreate: function handCreate() {
      var _this3 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          //   if (this.childData.initReadNumber >= this.childData.maxReadNumber) {
          //     return this.Alert({
          //       alertType: "valid",
          //       message: "初始读数不能大等于最大读数！",
          //     });
          //   }
          if (_this3.childData.changeReadNumber < _this3.childData.initReadNumberOld) {
            return _this3.Alert({
              alertType: "valid",
              message: "原仪表更换时读数不能小于原仪表上次读数！"
            });
          }

          if (_this3.keyValue > 0) {
            _this3.childData.readDateOld = _this3.childData.lastReadDate;
            _this3.childData.currentReadOld = _this3.childData.lastReadNum;
            changeShareTable(_this3.childData).then(function (response) {
              if (response.data.code === 200) {
                _this3.$emit("handCancle", true);

                _this3.Alert({
                  alertType: "update"
                });
              }
            });
          } else {
            _this3.Alert({
              alertType: "valid"
            });
          }
        } else {
          _this3.Alert({
            alertType: "valid"
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit("handCancle", false);
    }
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  }
};